import { Row } from '@tanstack/react-table';
import Badge from 'components/badge/Badge';
import {
  ConnectionConfigType,
  DisplayStatus,
  IntegrationStatus,
  InternalIntegrationSetting,
} from 'models/InternalIntegrationSetting';
import { INTERNAL_INTEGRATION_SETTINGS_BASE_QUERY_KEY } from 'pages/channels/integrationSettingsQuery';
import { useTranslation } from 'react-i18next';
import theme from 'styles/theme';
import NotAvailable from '../../../notAvailable/NotAvailable';
import DefaultSwitch from './DefaultSwitch/DefaultSwitch';
import InboundOAuthSwitch from './InboundOAuthSwitch';
import OutboundOAuthSwitch from './OutboundOAuthSwitch';

const StatusCell = ({ row }: { row: Row<InternalIntegrationSetting> }) => {
  const { t } = useTranslation();
  const { status } = row.original.agencySettings;
  const { displayStatus, connectionConfig } = row.original.integration;

  const integrationsQueryKey = [
    INTERNAL_INTEGRATION_SETTINGS_BASE_QUERY_KEY,
    'list',
  ];

  const isNotSupported = status === IntegrationStatus.NOT_SUPPORTED;
  const isPending = status === IntegrationStatus.PENDING;
  const isComingSoon = displayStatus === DisplayStatus.COMING_SOON;

  if (isNotSupported) {
    return <NotAvailable />;
  }

  if (isComingSoon) {
    return <p>{t('pageIntegrations.table.comingSoon')}</p>;
  }

  if (isPending) {
    return (
      <Badge backgroundColor={theme.colors.hostfullyYellow}>
        {t('pageIntegrations.table.pending')}
      </Badge>
    );
  }

  switch (connectionConfig?.type) {
    // Connect Via Partner button
    case ConnectionConfigType.INBOUND_OAUTH:
      return (
        <InboundOAuthSwitch
          integrationSetting={row.original}
          queryKey={integrationsQueryKey}
        />
      );

    // Custom activation page
    case ConnectionConfigType.OUTBOUND_OAUTH:
      return (
        <OutboundOAuthSwitch
          integrationSetting={row.original}
          queryKey={integrationsQueryKey}
        />
      );

    // Default switch
    case ConnectionConfigType.LEGACY_V2_SWITCH:
    case ConnectionConfigType.SWITCH:
      return (
        <DefaultSwitch
          integrationSetting={row.original}
          queryKey={integrationsQueryKey}
        />
      );

    default:
      return null;
  }
};

export default StatusCell;
